import React, {useEffect, useState, useRef} from 'react';
import styles from './Scale.module.css';

type ScaleProps = {
  start: number;
  end: number;
  labelEvery: number;
};

const Scale: React.FC<ScaleProps> = React.memo(({start, end, labelEvery}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const width = containerRef.current.getBoundingClientRect().width;
        if (width > 0) {
          setContainerWidth(width);
        }
      }
    };

    // Use setTimeout to ensure layout is complete
    const timeoutId = setTimeout(updateWidth, 0);

    const resizeObserver = new ResizeObserver(updateWidth);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      clearTimeout(timeoutId);
      resizeObserver.disconnect();
    };
  }, []);

  const marks = Array.from({length: end - start + 1}, (_, a) => a + start).reverse();

  const internalPadding = 13;
  const markWidth = 1;

  const rulerWidth = containerWidth > 0 ? containerWidth : 0;
  const itemWidth = rulerWidth > 0 ? (rulerWidth - internalPadding) / marks.length : 0;

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.rulerContainer} style={{paddingLeft: internalPadding / 2}}>
        {marks.map(mark => {
          const isLabeledMark = mark % labelEvery === 0 || mark === start || mark === end;
          return (
            <div
              key={mark.toString()}
              className={styles.line}
              style={{
                width: markWidth,
                marginLeft: (itemWidth - markWidth) / 2,
                marginRight: (itemWidth - markWidth) / 2,
                height: isLabeledMark ? '12px' : '100%',
              }}
            />
          );
        })}
      </div>
    </div>
  );
});

export {Scale};
